// React
import React, { useState, useEffect, useCallback } from "react";
import { BeatLoader } from "react-spinners";
import { useHistory, useLocation } from "react-router-dom";
import FilePreview from "react-preview-file";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import { Upload } from "@progress/kendo-react-upload";

// Css
import "./elderPhoto.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getFile, setPlacePhoto1, setPlacePhoto2, setUserPhoto } from "../../../service/mngt/elderService";
import { getAccountInfo } from "../../../service/mngt/accoutMngtService";

const ElderPhoto = ({ conn, rgnList, dongList, isNew, elderInfo, setElderInfo, submitData, dataItem, managerList }) => {
  const userInfo = getUser();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const isManager = userInfo.userTypeCode === 2002;

  const [dataState, setDataState] = useState({
    userId: "",
    fileIdUserPhoto: "",
    fileIdPlacePhoto1: "",
    fileIdPlacePhoto2: "",
    fileIdPlacePhoto3: "",
  });


  const [filesState, setFilesState] = useState({
    filesUserPhoto: [],
    fileInfoUserPhoto: [],
    fileIdUserPhoto: "",
    filesPlacePhoto1: [],
    fileInfoPlacePhoto1: [],
    fileIdPlacePhoto1: "",
    filesPlacePhoto2: [],
    fileInfoPlacePhoto2: [],
    fileIdPlacePhoto2: "",
  });
  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
    imgFilePlacePhoto1: "",
    imgFilePlacePhoto2: "",
    imgFilePlacePhoto3: "",
  });
  //사진 등록 시 미리보기
  const [previewFile, setPreviewFile] = useState({
    previewFileUserPhoto: "",
    previewFilePlacePhoto1: "",
    previewFilePlacePhoto2: "",
    previewFilePlacePhoto3: "",
  });

  // 저장 이벤트
  const saveEvt = () => {

  }

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.photoInfo = false;
      return item;
    });
  };

  const onAdd = e => {
    if(e.target.props.name === "userPhoto") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFileUserPhoto = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesUserPhoto = e.newState;
        item.fileInfoUserPhoto = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto1") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFilePlacePhoto1 = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesPlacePhoto1 = e.newState;
        item.fileInfoPlacePhoto1 = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto2") {
      setPreviewFile((previewFile) => {
        const item =  { ...previewFile };
        item.previewFilePlacePhoto2 = e.affectedFiles[0]
        return item;
      });
      setFilesState(state => {
        const item = { ...state };
        item.filesPlacePhoto2 = e.newState;
        item.fileInfoPlacePhoto2 = encodeURI(JSON.stringify(e.affectedFiles));
        return item;
      });
    } else if(e.target.props.name === "placePhoto3") {

    }

    console.log("onAdd", e.affectedFiles);

    // setDataSource({ ...dataSource, fileId: e.affectedFiles[0].fileId });
  };

  const onRemove = useCallback(
    // e => {
    //   console.log("onRemove", e.affectedFiles);

    //   setFilesState(state => {
    //     const item = { ...state };
    //     item.filesUserPhoto = e.newState;
    //     return item;
    //   });

    //   setPreviewFile([]);
    // },
    // [],
  );

  const onProgress = e => {
    const { affectedFiles, serverResponse } = e;
    console.log("onProgress.affectedFiles", affectedFiles);
    console.log("onProgress.serverResponse", serverResponse);

    setFilesState(state => {
      const item = { ...state };
      item.filesUserPhoto = e.newState;
      return item;
    });
  };

  const onStatusChangeUserPhoto = e => {
    
    //수정 버튼 클릭 시
    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      // setDataState({ ...dataState, fileIdUserPhoto });
      // dataState.fileIdUserPhoto = fileId;
      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdUserPhoto = fileId;
        setUserPhoto(conn, item);
        return item;
      })
      // closeEvt();
    }

    setFilesState(state => {
      const item = { ...state };
      item.filesUserPhoto = e.newState;
      return item;
    });
  }

  const onStatusChangePlacePhoto1 = e => {

    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      // setDataState({ ...dataState, fileIdUserPhoto });
      // dataState.fileIdUserPhoto = fileId;
      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdPlacePhoto1 = fileId;       
        setPlacePhoto1(conn, item);
        return item;
      })
    }

    setFilesState(state => {
      const item = { ...state };
      item.filesPlacePhoto1 = e.newState;
      return item;
    });
  }
 
  const onStatusChangePlacePhoto2 = e => {

    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      // setDataState({ ...dataState, fileIdUserPhoto });
      // dataState.fileIdUserPhoto = fileId;
      setDataState((dataState) => {
        const item = { ...dataState };
        item.fileIdPlacePhoto2 = fileId;       
        setPlacePhoto2(conn, item);
        return item;
      })
    }

    setFilesState(state => {
      const item = { ...state };
      item.filesPlacePhoto2 = e.newState;
      return item;
    });
  } 

  const setUserData = () => {
    setDataState((dataState) => {
      const item = { ...dataState };
      item.userId = dataItem.userId;
      getAccountInfo(conn, item)
      .then((result) => {
        if(result.fileIdUserPhoto) {
          getFile(conn, result.fileIdUserPhoto)
            .then(fileResponse => {
              const dataUri = 'data:image/png;base64,' + fileResponse;
              setImgFile((imgFile) => {
                const item = { ...imgFile};
                item.imgFileUserPhoto = dataUri;
                return item;
              });
            })
            .catch(e => console.log("getFile err = ", e));
        }
        if(result.fileIdPlacePhoto1) {
          getFile(conn, result.fileIdPlacePhoto1)
            .then(fileResponse => {
              const dataUri = 'data:image/png;base64,' + fileResponse;
              setImgFile((imgFile) => {
                const item = { ...imgFile};
                item.imgFilePlacePhoto1 = dataUri;
                return item;
              });
            })
            .catch(e => console.log("getFile err = ", e));
        }
        if(result.fileIdPlacePhoto2) {
          getFile(conn, result.fileIdPlacePhoto2)
            .then(fileResponse => {
              const dataUri = 'data:image/png;base64,' + fileResponse;
              setImgFile((imgFile) => {
                const item = { ...imgFile};
                item.imgFilePlacePhoto2 = dataUri;
                return item;
              });
            })
            .catch(e => console.log("getFile err = ", e));
        }
        
      })
      .catch((err) => {
        console.log("getAccountInfo err = ", err);
      })
      return item;
    })
  }

  useEffect(() => {
    setUserData();
  }, []);

  return (
    <Dialog title={"대상자 사진"} onClose={closeEvt}>
      <div className="photoDialog">
        <div className="leftPhotoDialog">
          <div className="itemText">대상자 사진</div>
          <div className="itemText">현장 사진 1</div>
          <div className="itemText">현장 사진 2</div>
          {/* <div className="itemText">현장 사진 3</div> */}
        </div>
        <div className="rightPhotoDialog">
          <div className="itemPhoto">
            <div className="imgBox">
              {/* 변경하기 시 미리보기 보여주고 변경하기 아닐때는 사진 보여줌 */}
              <div className="imgLnk">
                {!previewFile.previewFileUserPhoto ? (
                  imgFile.imgFileUserPhoto ? (
                    <img src={imgFile.imgFileUserPhoto} alt="사진" />
                  ) : (
                    <img src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFileUserPhoto.getRawFile()}>{preview => <img src={preview} />}</FilePreview>
                )}
              </div>
            </div>
            {/* <button
              className="imageUploadBtn"
              onClick={() => {
                document.getElementsByName("files")[0].click();
              }}>
              <span style={{ color: "black", fontSize: 20 }} className="k-icon k-i-photo-camera"></span>
            </button> */}
            <LocalizationProvider language="ko-KR">
              <IntlProvider locale="ko">
                <Upload
                  name="userPhoto"
                  className="fileUpload"
                  showFileList={false}
                  autoUpload={false}
                  batch={true}
                  multiple={false}
                  files={filesState.filesUserPhoto}
                  defaultFiles={[]}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  onProgress={onProgress}
                  onStatusChange={onStatusChangeUserPhoto}
                  withCredentials={true}
                  removeVerb={"DELETE"}
                  restrictions={{
                    allowedExtensions: [".jpg", ".png"],
                    maxFileSize: 10240000,
                  }}
                  saveMethod={"post"}
                  saveHeaders={{
                    "Content-Type": "multipart/form-data",
                    "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                  }}
                  saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoUserPhoto}
                  removeUrl={"/file/delete"}
                />
              </IntlProvider>
            </LocalizationProvider>
          </div>
          <div className="itemPhoto">
            <div className="imgBox">
              {/* 변경하기 시 미리보기 보여주고 변경하기 아닐때는 사진 보여줌 */}
              <div className="imgLnk">
                {!previewFile.previewFilePlacePhoto1 ? (
                  imgFile.imgFilePlacePhoto1 ? (
                    <img src={imgFile.imgFilePlacePhoto1} alt="사진" />
                  ) : (
                    <img src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFilePlacePhoto1.getRawFile()}>{preview => <img src={preview} />}</FilePreview>
                )}
              </div>
            </div>
            <LocalizationProvider language="ko-KR">
              <IntlProvider locale="ko">
                <Upload
                  name="placePhoto1"
                  className="fileUpload"
                  showFileList={false}
                  autoUpload={false}
                  batch={true}
                  multiple={false}
                  files={filesState.filesPlacePhoto1}
                  defaultFiles={[]}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  onProgress={onProgress}
                  onStatusChange={onStatusChangePlacePhoto1}
                  withCredentials={true}
                  removeVerb={"DELETE"}
                  restrictions={{
                    allowedExtensions: [".jpg", ".png"],
                    maxFileSize: 10240000,
                  }}
                  saveMethod={"post"}
                  saveHeaders={{
                    "Content-Type": "multipart/form-data",
                    "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                  }}
                  saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoPlacePhoto1}
                  removeUrl={"/file/delete"}
                />
              </IntlProvider>
            </LocalizationProvider>
          </div>
          <div className="itemPhoto">
            <div className="imgBox">
              {/* 변경하기 시 미리보기 보여주고 변경하기 아닐때는 사진 보여줌 */}
              <div className="imgLnk">
                {!previewFile.previewFilePlacePhoto2 ? (
                  imgFile.imgFilePlacePhoto2 ? (
                    <img src={imgFile.imgFilePlacePhoto2} alt="사진" />
                  ) : (
                    <img src="/images/mobile/photo.png" alt="사진" />
                  )
                ) : (
                  <FilePreview file={previewFile.previewFilePlacePhoto2.getRawFile()}>{preview => <img src={preview} />}</FilePreview>
                )}
              </div>
            </div>
            <LocalizationProvider language="ko-KR">
              <IntlProvider locale="ko">
                <Upload
                  name="placePhoto2"
                  className="fileUpload"
                  showFileList={false}
                  autoUpload={false}
                  batch={true}
                  multiple={false}
                  files={filesState.filesPlacePhoto2}
                  defaultFiles={[]}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  onProgress={onProgress}
                  onStatusChange={onStatusChangePlacePhoto2}
                  withCredentials={true}
                  removeVerb={"DELETE"}
                  restrictions={{
                    allowedExtensions: [".jpg", ".png"],
                    maxFileSize: 10240000,
                  }}
                  saveMethod={"post"}
                  saveHeaders={{
                    "Content-Type": "multipart/form-data",
                    "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                  }}
                  saveUrl={"/api/v2.2/file/upload?fileInfo=" + filesState.fileInfoPlacePhoto2}
                  removeUrl={"/file/delete"}
                />
              </IntlProvider>
            </LocalizationProvider>
          </div>
          {/* <div className="processPhotoDialog">
            <button onClick={saveEvt}>저장</button>
            <button onClick={closeEvt}>취소</button>
          </div> */}
        </div>
      </div>
    </Dialog>
  );
};
export default ElderPhoto;
